/**
 * Date utility functions
 */

/**
 * Format a date string or Date object to a long date format (e.g., "January 15, 2024")
 * Used for invoice date display
 */
export function formatDateLong(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

/**
 * Format a date string or ISO timestamp to a readable format with relative time
 * Used for history items (e.g., "5m ago • Jan 15, 2024 2:30 PM")
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  // Format the date part
  const datePart = date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined,
  });

  // Format the time part
  const timePart = date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

  // Add relative time for recent items
  if (diffMins < 1) {
    return `Just now`;
  } else if (diffMins < 60) {
    return `${diffMins}m ago • ${datePart} ${timePart}`;
  } else if (diffHours < 24) {
    return `${diffHours}h ago • ${datePart} ${timePart}`;
  } else if (diffDays < 7) {
    return `${diffDays}d ago • ${datePart} ${timePart}`;
  } else {
    return `${datePart} ${timePart}`;
  }
}
